export default __webpack_public_path__ + "static/timeline-image-03-03cbad7400465a517ea3c5ec63da14f1.jpg";